const POSTHOG_CAMPAIGN_PROPERTY_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "utm_term",
  "gad_source",
  "mc_cid",
  "gclid",
  "gclsrc",
  "dclid",
  "gbraid",
  "wbraid",
  "fbclid",
  "msclkid",
  "twclid",
  "li_fat_id",
  "igshid",
  "ttclid",
  "rdt_cid",
  "epik",
  "qclid",
  "sccid",
  "irclid",
  "_kx"
]

const URL_PROPERTY_KEYS = [
  "$current_url",
  "$referrer",
  "$pathname",
  "$initial_current_url",
  "$initial_referrer",
  "$initial_pathname",
  "$session_entry_url",
  "$session_entry_current_url",
  "$session_entry_referrer",
  "$session_entry_pathname",
  "$prev_pageview_pathname",
  "current_url",
  "url",
  "href",
  "pathname",
  "referrer"
]

const REFERRER_PROPERTY_KEYS = new Set([
  "$referrer",
  "$initial_referrer",
  "$session_entry_referrer",
  "referrer"
])

export function scrubPosthogEvent(event) {
  if (!event) return event

  scrubPosthogProperties(event.properties)
  scrubPosthogProperties(event.properties?.$set)
  scrubPosthogProperties(event.properties?.$set_once)
  scrubPosthogProperties(event.$set)
  scrubPosthogProperties(event.$set_once)

  return event
}

function scrubPosthogProperties(properties) {
  if (!properties) return

  deletePosthogCampaignProperties(properties)

  for (const key of URL_PROPERTY_KEYS) {
    if (properties[key]) {
      properties[key] = REFERRER_PROPERTY_KEYS.has(key)
        ? scrubReferrerValue(properties[key])
        : scrubPathValue(properties[key])
    }
  }
}

function deletePosthogCampaignProperties(properties) {
  for (const key of POSTHOG_CAMPAIGN_PROPERTY_KEYS) {
    delete properties[key]
    delete properties[`$initial_${key}`]
    delete properties[`$session_entry_${key}`]
  }
}

export function sanitizePathValue(value) {
  if (typeof value !== "string") return value

  try {
    const parsed = new URL(value, baseOrigin())
    return normalizeSensitivePath(parsed.pathname || "/")
  } catch {
    return normalizeSensitivePath(value.split(/[?&#]/)[0] || "/")
  }
}

const scrubPathValue = sanitizePathValue

function scrubReferrerValue(value) {
  if (typeof value !== "string") return value

  try {
    const parsed = new URL(value, baseOrigin())
    return sanitizeHost(parsed.hostname) || "/"
  } catch {
    return sanitizeHost(value.split(/[?&]/)[0].split("/")[0]) || "/"
  }
}

function sanitizeHost(value) {
  if (!value) return null

  const sanitized = value.toLowerCase().replace(/^www\./, "")
  return /^[a-z0-9.-]+$/.test(sanitized) ? sanitized.slice(0, 120) : null
}

function baseOrigin() {
  return globalThis.location?.origin || "https://kova.test"
}

function normalizeSensitivePath(path) {
  if (!path || !path.startsWith("/")) return "/"

  let match = path.match(/^\/password_resets\/[^/]+(?<suffix>\/edit)?\/?$/)
  if (match) return `/password_resets/:token${match.groups.suffix || ""}`

  if (/^\/mcp\/[^/]+\/?$/.test(path)) return "/mcp/:session_id"
  if (/^\/b\/[^/]+\/?$/.test(path)) return "/b/:share_token"

  match = path.match(/^\/founding-member\/invitations\/[^/]+(?<suffix>\/(?:success|cancel))?\/?$/)
  if (match) return `/founding-member/invitations/:signed_id${match.groups.suffix || ""}`

  match = path.match(/^\/r\/[^/]+(?<suffix>\/preview(?:\.[^/]+)?)?\/?$/)
  if (match) return `/r/:share_token${match.groups.suffix || ""}`

  match = path.match(/^\/rails\/active_storage\/blobs\/(?<mode>redirect|proxy)\/[^/]+(?:\/.*)?$/)
  if (match) return `/rails/active_storage/blobs/${match.groups.mode}/:signed_id`

  if (/^\/rails\/active_storage\/blobs\/[^/]+(?:\/.*)?$/.test(path)) {
    return "/rails/active_storage/blobs/:signed_id"
  }

  match = path.match(/^\/rails\/active_storage\/representations\/(?<mode>redirect|proxy)\/[^/]+\/[^/]+(?:\/.*)?$/)
  if (match) return `/rails/active_storage/representations/${match.groups.mode}/:signed_blob_id/:variation_key`

  if (/^\/rails\/active_storage\/representations\/[^/]+\/[^/]+(?:\/.*)?$/.test(path)) {
    return "/rails/active_storage/representations/:signed_blob_id/:variation_key"
  }

  if (/^\/rails\/active_storage\/disk\/[^/]+\/?$/.test(path)) return "/rails/active_storage/disk/:encoded_token"

  return path
}
